import JsPDF from 'jspdf'
import 'jspdf-autotable'

export default {
  data () {
    return {
      pagosPdf: [],
      aplicacionesPdf: [],
      recibo: {},
      pago: {},
      detalles: [],
      columns: [],
      columnStyles: {},
      emitioRecibio: 'Emitió',
    }
  },
  methods: {
    generarPdfRecibo: async function (reciboId) {
      await this.$store.dispatch('axiosMod/getData', { url: '/api/recibo_pdf/' + reciboId }).then(response => {
        this.pagosPdf = response[2]
        this.aplicacionesPdf = response[1]
        this.recibo = response[0]
        this.emitioRecibio = 'Recibió: '
        this.generarReciboPdf()
      })
    },
    generarPdfPago: async function (pagoId) {
      await this.$store.dispatch('axiosMod/getData', { url: '/api/pagos_pdf_get/' + pagoId }).then(response => {
        this.aplicacionesPdf = response[2]
        this.detalles = response[1]
        this.pago = response[0]
        this.emitioRecibio = 'Emitió pago: '
        this.generarPagoPdf()
      })
    },

    /* RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO RECIBO */

    generarReciboPdf: async function (item = this.recibo) {
      /* PREPARO DATA */

      /* PREPARO DOCUMENTO */
      const doc = new JsPDF('p', 'mm', 'a4')
      doc.setProperties({
        title: 'Comprobante#' + item.id,
      })

      var ejeY = 70

      /* NOTA */
      if (item.nota) {
        doc.setFontSize(12).setTextColor(0, 0, 0)
        // doc.text('Observación:', 14, 70)
        doc.setFontSize(11).setTextColor(127, 127, 127)

        var subStrings = doc.splitTextToSize(item.nota, 180)

        for (var f = 0; f < subStrings.length; f++) {
          doc.text(subStrings[f], 14, ejeY)
          ejeY = ejeY + 5
        }
      }
      /* TABLA PAGOS */
      doc.autoTable({
        didDrawCell: (data) => {
          if (data.section === 'body' && data.column.index === 0 && data.row.index === 0) {
            doc.setFillColor(175, 150, 59)
            doc.rect(11, data.cell.y - 15, 189.1, 6, 'DF')
            doc.setFontSize(14).setTextColor(255, 255, 255)
            doc.text('PAGOS', 98, data.cell.y - 10)
          }
        },
        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        margin: { top: 80, bottom: 35 },
        startY: ejeY + 10, /* EJE Y + 10 PARA UBICAR LA TABLA AL FINAL DE LA NOTA */
        body: this.pagosPdf,
        setFillColor: false,
        columns: [
          { header: 'Tipo de pago', dataKey: 'tipo_pago', setFillColor: 'red' },
          { header: 'Banco', dataKey: 'banco' },
          { header: 'Numero', dataKey: 'numero' },
          { header: 'Vencimiento', dataKey: 'vencimiento' },
          { header: 'Importe', dataKey: 'monto' },
        ],
        columnStyles: {
          1: { cellWidth: 37 },
          2: { cellWidth: 33 },
          3: { cellWidth: 33 },
          4: { cellWidth: 33 },
        },
      })
      /* TOTAL */
      doc.setFontSize(16).setTextColor(0, 0, 0)
      doc.text('TOTAL', 130, doc.lastAutoTable.finalY + 10)
      doc.text(item.moneda.simbolo + item.monto, 163, doc.lastAutoTable.finalY + 10)

      /* TABLA APLICACIONES */
      if (this.aplicacionesPdf.length > 0) {
        doc.autoTable({
          didDrawCell: (data) => {
            if (data.section === 'body' && data.column.index === 0 && data.row.index === 0) {
              doc.setFillColor(175, 150, 59)
              doc.rect(11, data.cell.y - 15, 189.1, 6, 'DF')
              doc.setFontSize(14).setTextColor(255, 255, 255)
              doc.text('APLICACIONES', 90, data.cell.y - 10)
            }
          },
          styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
          margin: { top: 80, bottom: 35 },
          startY: doc.lastAutoTable.finalY + 25, /* Y DE ULTIMA TABLA + 25 PARA UBICAR APLICACIONES AL FINAL DE PAGOS */
          body: this.aplicacionesPdf,
          setFillColor: false,
          columns: [
            { header: 'Cuota', dataKey: 'cuota' },
            { header: 'Vencimiento', dataKey: 'vencimiento' },
            { header: 'Monto', dataKey: 'monto' },
          ],
          columnStyles: {
            0: { cellWidth: 82 },
            1: { cellWidth: 82 },
          },
        })
      }
      this.prepareHeaderReciboPdf(doc, item)
      // doc.save('Comprobante' + item.id + '.pdf')
      window.open(doc.output('bloburl'))
    },

    /* HEADER */
    prepareHeaderReciboPdf (doc, item) {
      var pageCount = doc.internal.getNumberOfPages()
      const logo = require(`@/assets/${'LogoPri936x526.png'}`)
      var imgLogo = new Image()
      imgLogo.src = logo

      /* PREPARO DATA */
      var emisor = ''
      if (item.jugador_id) {
        emisor = item.jugador.fullName
      } else if (item.club_id) {
        emisor = item.club.descripcion
      } else if (item.contacto_id) {
        emisor = item.contacto.razon_social
      }
      // receptor tambien puede ser emisor
      var receptor = ''
      if (item.user) {
        receptor = ((item.user.lastname) ? item.user.lastname : '') + ' ' + item.user.name
      }

      for (let i = 0; i < pageCount; i++) {
        doc.setPage(i)
        /* TITULO RECIBO */
        doc.setFillColor(175, 150, 59)
        doc.rect(11, 9, 189.1, 8, 'F')
        doc.setFontSize(18).setTextColor(255, 255, 255)
        doc.text('RECIBO', 95, 15)

        /* NRO RECIBO */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text('N° Recibo: ', 14, 30)
        doc.setFontSize(11).setTextColor(127, 127, 127)
        doc.text(('0000000' + item.id).slice(-7), 36, 30)

        /* FECHA */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text('Fecha: ', 14, 40)
        doc.setFontSize(11).setTextColor(127, 127, 127)
        doc.text(item.fecha, 29, 40)

        /* EMISOR Y MONTO */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text('Recibimos de: ', 14, 50)
        doc.setFontSize(11).setTextColor(127, 127, 127)
        doc.text(emisor, 42, 50)

        /* receptor */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text(this.emitioRecibio, 14, 60)
        doc.setFontSize(11).setTextColor(127, 127, 127)
        doc.text(receptor, 30, 60)

        /* var string = emisor + ' ' + item.moneda.simbolo + item.monto + ' (' + item.montoLetras + ' ' + item.moneda.descripcion + ') '
        var subStrings = doc.splitTextToSize(string, 110)
        var ejeY = 50

        for (var f = 0; f < subStrings.length; f++) {
          doc.text(subStrings[f], 42, ejeY)
          ejeY = ejeY + 5
        } */

        /* LOGO */
        doc.addImage(imgLogo, 'PNG', 144, 20, 55, 40)

        /* SEPARADOR */
        doc.setDrawColor(175, 150, 59)
        doc.setLineWidth(0.5)
        doc.line(11, 65, 200, 65)

        this.prepareFooterPdf(doc)
      }
    },

    /* FOOTER */
    prepareFooterPdf (doc) {
      var pageCount = doc.internal.getNumberOfPages()

      for (let i = 0; i < pageCount; i++) {
        doc.setPage(i)
        var y = 265

        /* SEPARADOR */
        doc.setDrawColor(175, 150, 59)
        doc.setLineWidth(0.5)
        doc.line(11, y, 200, y)

        y = y + 10
        /* NRO RECIBO */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text(doc.internal.getCurrentPageInfo().pageNumber + ' de ' + pageCount, 98, y)
      }
    },

    /* PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO  PAGO PAGO  */

    generarPagoPdf: async function (item = this.pago) {
      /* PREPARO DATA */

      /* PREPARO DOCUMENTO */
      const doc = new JsPDF('p', 'mm', 'a4')
      doc.setProperties({
        title: 'Comprobante#' + item.id,
      })

      var ejeY = 70

      /* NOTA */
      if (item.nota) {
        doc.setFontSize(12).setTextColor(0, 0, 0)
        // doc.text('Observación:', 14, 70)
        doc.setFontSize(11).setTextColor(127, 127, 127)

        var subStrings = doc.splitTextToSize(item.nota, 180)

        for (var f = 0; f < subStrings.length; f++) {
          doc.text(subStrings[f], 14, ejeY)
          ejeY = ejeY + 5
        }
      }
      /* TABLA PAGOS */
      doc.autoTable({
        didDrawCell: (data) => {
          if (data.section === 'body' && data.column.index === 0 && data.row.index === 0) {
            doc.setFillColor(175, 150, 59)
            doc.rect(11, data.cell.y - 15, 189.1, 6, 'DF')
            doc.setFontSize(14).setTextColor(255, 255, 255)
            doc.text('DETALLE', 97, data.cell.y - 10)
          }
        },
        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
        margin: { top: 80, bottom: 35 },
        startY: ejeY + 10, /* EJE Y + 10 PARA UBICAR LA TABLA AL FINAL DE LA NOTA */
        body: this.detalles,
        setFillColor: false,
        columns: [
          { header: 'Tipo de pago', dataKey: 'tipo_de_pago', setFillColor: 'red' },
          { header: 'Banco', dataKey: 'banco' },
          { header: 'Numero', dataKey: 'numero' },
          { header: 'Vencimiento', dataKey: 'vencimiento' },
          { header: 'Importe', dataKey: 'monto' },
        ],
        columnStyles: {
          1: { cellWidth: 37 },
          2: { cellWidth: 33 },
          3: { cellWidth: 33 },
          4: { cellWidth: 33 },
        },
      })
      /* TOTAL */
      doc.setFontSize(16).setTextColor(0, 0, 0)
      doc.text('TOTAL', 130, doc.lastAutoTable.finalY + 10)
      doc.text(item.moneda.simbolo + item.monto, 163, doc.lastAutoTable.finalY + 10)

      /* TABLA APLICACIONES */
      this.prepareAplicacionesPago(doc, item)

      if (this.aplicacionesPdf.length > 0) {
        doc.autoTable({
          didDrawCell: (data) => {
            if (data.section === 'body' && data.column.index === 0 && data.row.index === 0) {
              doc.setFillColor(175, 150, 59)
              doc.rect(11, data.cell.y - 15, 189.1, 6, 'DF')
              doc.setFontSize(14).setTextColor(255, 255, 255)
              doc.text('APLICACIONES', 90, data.cell.y - 10)
            }
          },
          styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0] },
          margin: { top: 80, bottom: 35 },
          startY: doc.lastAutoTable.finalY + 25, /* Y DE ULTIMA TABLA + 25 PARA UBICAR APLICACIONES AL FINAL DE PAGOS */
          body: this.aplicacionesPdf,
          setFillColor: false,
          columns: this.columns,
          columnStyles: this.columnStyles,
        })
      }
      this.prepareHeaderPagoPdf(doc, item)
      window.open(doc.output('bloburl'))
    },

    /* HEADER */
    prepareHeaderPagoPdf (doc, item) {
      var pageCount = doc.internal.getNumberOfPages()
      const logo = require(`@/assets/${'LogoPri936x526.png'}`)
      var imgLogo = new Image()
      imgLogo.src = logo

      /* PREPARO DATA */
      var emisor = ''
      if (item.jugador_id) {
        emisor = item.jugador.fullName
      } else if (item.staff_id) {
        emisor = item.staff.fullName
      } else if (item.contacto_id) {
        emisor = item.contacto.razon_social
      } else {
        emisor = item.contactoFactura.razon_social
      }

      var receptor = ''
      if (item.user) {
        receptor = ((item.user.lastname) ? item.user.lastname : '') + ' ' + item.user.name
      }

      for (let i = 0; i < pageCount; i++) {
        doc.setPage(i)
        /* TITULO RECIBO */
        doc.setFillColor(175, 150, 59)
        doc.rect(11, 9, 189.1, 8, 'F')
        doc.setFontSize(18).setTextColor(255, 255, 255)
        doc.text('PAGO', 97, 15)

        /* NRO RECIBO */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text('N° Pago: ', 14, 30)
        doc.setFontSize(11).setTextColor(127, 127, 127)
        doc.text(('0000000' + item.id).slice(-7), 34, 30)

        /* FECHA */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text('Fecha: ', 14, 40)
        doc.setFontSize(11).setTextColor(127, 127, 127)
        doc.text(item.fecha, 29, 40)

        /* EMISOR Y MONTO */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text('Pagamos a: ', 14, 50)
        doc.setFontSize(11).setTextColor(127, 127, 127)
        doc.text(emisor, 38, 50)

        /* emisor */
        doc.setFontSize(12).setTextColor(0, 0, 0)
        doc.text(this.emitioRecibio, 14, 60)
        doc.setFontSize(11).setTextColor(127, 127, 127)
        doc.text(receptor, 38, 60)

        /* var string = emisor + ' ' + item.moneda.simbolo + item.monto + ' (' + item.montoLetras + ' ' + item.moneda.descripcion + ') '
        var subStrings = doc.splitTextToSize(string, 110)
        var ejeY = 50

        for (var f = 0; f < subStrings.length; f++) {
          doc.text(subStrings[f], 42, ejeY)
          ejeY = ejeY + 5
        } */

        /* LOGO */
        doc.addImage(imgLogo, 'PNG', 144, 20, 55, 40)

        /* SEPARADOR */
        doc.setDrawColor(175, 150, 59)
        doc.setLineWidth(0.5)
        doc.line(11, 65, 200, 65)

        this.prepareFooterPdf(doc)
      }
    },

    prepareAplicacionesPago (doc, item = this.pago) {
      if (item.tipoAplicaciones === 'factura') {
        this.columns = [
          { header: 'Factura', dataKey: 'numero', setFillColor: 'red' },
          { header: 'Vencimiento', dataKey: 'fecha_vencimiento' },
          { header: 'Importe', dataKey: 'total' },
        ]
        this.columnStyles = {
          0: { cellWidth: 82 },
          1: { cellWidth: 82 },
        }
      }
      if (item.tipoAplicaciones === 'solicitud extraordinaria') {
        this.columns = [
          { header: 'Descripcion', dataKey: 'obligacion', setFillColor: 'red' },
          { header: 'Cantidad', dataKey: 'cantidad' },
        ]
        this.columnStyles = {
          0: { cellWidth: 146 },
          1: { cellWidth: 35.7793333333 },
        }
      }
      if (item.tipoAplicaciones === 'obligacion representante') {
        this.columns = [
          { header: 'Descripcion', dataKey: 'obligacion', setFillColor: 'red' },
          { header: 'Vencimiento', dataKey: 'vencimiento' },
          { header: 'Cantidad', dataKey: 'cantidad' },
        ]
        this.columnStyles = {
          0: { cellWidth: 80 },
          1: { cellWidth: 80 },
        }
      }
    },
  },
}
